<template>
  <div class="sign-manage-content conmon-top">
    <el-row class="search-title common-table-top" style="margin-top: 20px">
      <el-col :span="4" class="table-title">
        <i class="el-icon-document" style="font-weight: bold;"></i>
        <span class="order-list-search-span">数据列表</span>
      </el-col>
    </el-row>
    <el-row class="import-data-title">
       <el-table
        :data="tableData"
        v-loading="loading"
        class="table msg-list">
           <template slot="empty">
               <div class="newTableEmpty">没有更多数据了</div>
           </template>
         <el-table-column type="expand">
           <template slot-scope="props">
             <el-form label-position="left" inline class="demo-table-expand">
               <el-form-item class="msg-content" label="内容">
                 <span>{{ props.row.content }}</span>
               </el-form-item>
             </el-form>
           </template>
         </el-table-column>
        <el-table-column
          prop="sms_name"
          label="短信名称"
          width="">
        </el-table-column>
        <el-table-column
          prop="model_name"
          label="受众类型"
          width="135">
        </el-table-column>
        <!--<el-table-column-->
          <!--prop="content"-->
          <!--label="内容"-->
          <!--width="">-->
        <!--</el-table-column>-->
        <el-table-column
          prop="query_name"
          label="群组"
          width="135">
        </el-table-column>
        <el-table-column
          prop=""
          width="135"
          label="创建时间">
           <template slot-scope="scope">
            {{ scope.row.create_time | formatDate }}
          </template>
        </el-table-column>
        <el-table-column
          prop=""
          width="135"
          label="发送时间">
           <template slot-scope="scope">
            {{ scope.row.send_time | formatDate }}
          </template>
        </el-table-column>
        <el-table-column
          prop=""
          width="70"
          label="状态">
           <template slot-scope="scope">
               <div v-if="scope.row.status === 0"><span class="pointGray"></span>待发送</div>
            <div v-else><span class="pointGreen"></span>已发送</div>
          </template>
        </el-table-column>
           <el-table-column
                   prop=""
                   width="70"
                   label="操作">
               <template slot-scope="scope">
                   <div v-if="butsObj.statistics" class="op-link" @click="statisticsAction(scope.row.id)">
                       统计
                   </div>
               </template>
           </el-table-column>
      </el-table>
       <div class="table-foot">
        <el-pagination
          class="table-foot-pagination"
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-size="limit"
          layout="total, prev, pager, next, jumper"
          :total="totalCount">
        </el-pagination>
      </div>
    </el-row>
    <el-dialog
      title="短信统计"
      :visible.sync="dialogVisible"
      width="400px;"
      class="cellDialog">
      <el-table
        :data="statisticTableData"
        border
        class="table">
        <el-table-column
          prop="sendCount"
          label="发送数"
          width="">
        </el-table-column>
        <el-table-column
          prop="clickCount"
          label="点击链接"
          width="">
        </el-table-column>
        <el-table-column
          prop="percent"
          label="点击率"
          width="">
        </el-table-column>
        <el-table-column
          prop=""
          label="操作">
           <template>
            <div class="op-link" @click="exportDataAction">导出</div>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button class="dialog-cancel-btn" style="margin-right: 20px" @click="dialogVisible = false">关 闭</el-button>
        <!--<el-button class="dialog-confirm-btn" type="primary" style="margin-right: 20px" @click="dialogVisible = false">确 定</el-button>-->
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { exportSmsStat, getSendMegListRecord, exportMegSendRecod, megSendRecodStatistic } from '@/api/customer.js'
import { butonsList, getMenId } from '@/api/analyse.js'
export default {
  name: 'importData',
  data() {
    return {
      loading: true,
      tableData: [],
      statisticTableData: [],
      page: 1,
      limit: 10,
      totalCount: 0,
      dialogVisible: false,
      queryId: '',
      butsObj: { // button按钮列表
        statistics: false
      }
    }
  },
  methods: {
    // 获取可用菜单按钮列表
    getButtonsList () {
      let params = {
        systemCode: 'ZY_INTELLIQUOR',
        authKey: Lockr.get('authKey'),
        sessionId: Lockr.get('sessionId'),
        menuId: getMenId(this.$route.path)
      }
      butonsList(params).then(res=>{
        if (res.data.code === '200') {
          let result = res.data.result || []
          let arrObj = Object.keys(this.butsObj)
          let newarr  = result.map((item)=>{
            return item.perms
          })
          arrObj.map(it=> {
            if (newarr.indexOf(it)!==-1) {
              this.butsObj[it] = true
            } else {
              this.butsObj[it] = false
            }
          })
        }
      }).catch(err=>{
        this.$message.error(err)
      })
    },
    statisticsAction(id) {
      this.queryId = id
      this.dialogVisible = true
      megSendRecodStatistic(id).then(res => {
        this.statisticTableData = [res.data.data.list]
      })
    },
    exportDataAction() {
      exportSmsStat(this.queryId).then(response => {
        this.download(response)
      }).catch((error) => {
        console.log(error)
        _g.toastMsg('error', '文件不存在')
      })
    },
    // 下载文件
    download (data) {
      if (!data) {
        return
      }
      var now = new Date()
      var year = now.getFullYear()
      var month = (now.getMonth() + 1 < 10 ? '0' + (now.getMonth() + 1) : (now.getMonth()) + 1)
      console.log(month)
      var date = now.getDate()
      var hour = now.getHours()
      var minute = now.getMinutes()
      var second = now.getSeconds()
      let time = ''
      time = year + '' + month + '' + date + '' + hour + '' + minute + '' + second
      var blob = new Blob([data.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' }) // application/vnd.openxmlformats-officedocument.spreadsheetml.sheet这里表示xlsx类型
      var downloadElement = document.createElement('a')
      var href = window.URL.createObjectURL(blob) // 创建下载的链接
      downloadElement.href = href
      downloadElement.download = time + '.xlsx' // 下载后文件名
      document.body.appendChild(downloadElement)
      downloadElement.click() // 点击下载
      document.body.removeChild(downloadElement) // 下载完成移除元素
      window.URL.revokeObjectURL(href) // 释放掉blob对象
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done()
        })
        .catch(_ => {})
    },
    changeSearchType(id) {
      this.dialogVisible = true
    },
    // 处理分页
    handleSizeChange(val) {
      this.limit = val
      this.load()
    },
    handleCurrentChange(page) {
      this.page = page
      this.load()
    },
    load() {
      this.loading = true
      getSendMegListRecord(this.page).then(res => {
        this.tableData = res.data.data.list
        this.totalCount = res.data.data.total
        console.log(res)
      })
      this.openLoading()
    },
    // 数据加载时的动画
    openLoading() {
      setTimeout(() => {
        this.loading = false
      }, 500)
    }
  },
  created() {
    this.getButtonsList()
    this.load()
  },
  components: {
  }
}
</script>

<style scoped>
    .el-table td .cell:empty::before{
        content:'——';
        color:gray;
    }
.sign-manage-title {
  background:#ecf6ff;
  border: 1px solid #E4e4e4;
  height:60px;
  padding:10px;
  line-height: 40px;
  margin-top: 10px;
}
.table-title {
  text-align: left;
}
</style>
